import React, { createContext, useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import appActions from '../store/actions/app';
var ErrorContext = createContext();
var ErrorContextProvider = props => {
  var {
    children,
    markErrorHandled,
    unhandledErrors
  } = props;
  var errorApi = useMemo(() => ({
    markErrorHandled
  }), [markErrorHandled]);
  var contextValue = useMemo(() => [unhandledErrors, errorApi], [errorApi, unhandledErrors]);
  return /*#__PURE__*/React.createElement(ErrorContext.Provider, {
    value: contextValue
  }, children);
};
var mapStateToProps = _ref => {
  var {
    unhandledErrors
  } = _ref;
  return {
    unhandledErrors
  };
};
var mapDispatchToProps = {
  markErrorHandled: appActions.markErrorHandled
};
export default connect(mapStateToProps, mapDispatchToProps)(ErrorContextProvider);
export var useErrorContext = () => useContext(ErrorContext);